export enum SettingType {
    Matching,
    Validation
}